module.exports = __webpack_public_path__ + "img/icon_warning.cc47734c.svg";